import React, { useState } from 'react';
import { MapPin, Phone, Instagram, Globe, Mail } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const whatsappMessage = `*Yeni Mesaj*\n\nAd: ${formData.name}\nEmail: ${formData.email}\nTelefon: ${formData.phone}\nMesaj: ${formData.message}`;
    const whatsappUrl = `https://wa.me/994999737000?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="min-h-screen bg-white pt-[73px]">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-serif mb-12 text-center">Əlaqə</h1>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div>
            <h2 className="text-2xl font-serif mb-6">Əlaqə Məlumatları</h2>
            <div className="space-y-6">
{/*               <div className="flex items-start gap-4"> */}
{/*                 <MapPin className="w-6 h-6 text-gray-700 mt-1" /> */}
{/*                 <div> */}
{/*                   <h3 className="font-medium mb-1">Ünvan</h3> */}
{/*                   <p className="text-gray-600">Metropark, 4-cü mərtəbə</p> */}
{/*                   <p className="text-gray-600">Bakı, Azərbaycan</p> */}
{/*                 </div> */}
{/*               </div> */}

              <div className="flex items-start gap-4">
                <Phone className="w-6 h-6 text-gray-700 mt-1" />
                <div>
                  <h3 className="font-medium mb-1">Telefon</h3>
                  <a
                    href="tel:+994999737000"
                    className="text-gray-600 hover:text-black"
                  >
                    +994 999737000
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Instagram className="w-6 h-6 text-gray-700 mt-1" />
                <div>
                  <h3 className="font-medium mb-1">Instagram</h3>
                  <a
                    href="https://www.instagram.com/laliel.az"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:text-black"
                  >
                    @laliel.az
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Globe className="w-6 h-6 text-gray-700 mt-1" />
                <div>
                  <h3 className="font-medium mb-1">Vebsayt</h3>
                  <a
                    href="https://www.lalielstore.com"
                    className="text-gray-600 hover:text-black"
                  >
                    www.laliel.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Mail className="w-6 h-6 text-gray-700 mt-1" />
                <div>
                  <h3 className="font-medium mb-1">Email</h3>
                  <a
                    href="mailto:info@laliel.com"
                    className="text-gray-600 hover:text-black"
                  >
                    info@laliel.com
                  </a>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="mt-8 rounded-lg overflow-hidden border border-gray-200">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3039.5348203467853!2d49.8479!3d40.3777!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDIyJzM5LjciTiA0OcKwNTAnNTIuNCJF!5e0!3m2!1sen!2saz!4v1234567890"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Location Map"
              ></iframe>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <h2 className="text-2xl font-serif mb-6">Mesaj Göndərin</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">Ad Soyad</label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-black"
                  placeholder="Adınızı daxil edin"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Email</label>
                <input
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-black"
                  placeholder="email@example.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Telefon</label>
                <input
                  type="tel"
                  required
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-black"
                  placeholder="+994 XX XXX XX XX"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Mesaj</label>
                <textarea
                  required
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  rows="5"
                  className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-black"
                  placeholder="Mesajınızı yazın..."
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full py-4 bg-black text-white font-medium tracking-wider hover:bg-gray-800 transition-colors"
              >
                Mesaj Göndər
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;